// extracted by mini-css-extract-plugin
export default {"header":"fH","light":"gH","dark":"hH","headertitle":"iH","fname":"jH","headerContent":"kH","right":"lH","descriptionwrapper":"mH","appear":"nH","second":"oH","third":"pH","forth":"qH"};
    if(module.hot) {
      // 1713912567056
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  